/* eslint-disable indent */
import React from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import { CSVLink } from "react-csv";

import FileDrop from 'react-file-drop';
import CSVReader from 'react-csv-reader'
import * as CSV from 'csv-string';
import './index.scss';

Modal.setAppElement('#root');

const papaparseOptions = {
  //header: true,
  dynamicTyping: true,
  skipEmptyLines: true,
  transformHeader: header =>
    header
      .toLowerCase()
      .replace(/\W/g, '')
}

class Layover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state={
      csvfile:undefined,
      csvdata:[],
      fileloaded:false,
      filename:undefined,
      disclaimer:false,
      review:false,
      sampledata:[],
      justpreview:this.props.preview
    }
    let filereader;
  }

  componentDidMount =()=>{
   let samplearray = [] 
   let header = ['name','phone'];
   samplearray.push(header);
   console.log("props",this.props);
   if(this.props.business){
     let name = this.props.business.info.FIRST_NAME;
     let phone = ( Object.keys(this.props.business.phoneList)[0])? this.formatPhoneNumber(Object.keys(this.props.business.phoneList)[0]) :'(123) 456 4567'
     let tails = [[name],[phone]];
     samplearray.push(tails);
   }else{
    let tails = ['Sample Name','(123) 456 4567'];
    samplearray.push(tails);
   }
   this.setState({
    sampledata:samplearray,
    review:this.props.preview,
    justpreview:this.props.preview
   });
  }

  componentWillReceiveProps(nextProps){
    console.log("props",this.props);
    this.setState({
      review:this.props.preview,
      justpreview:this.props.preview
     }); 
  }
  disableButton=()=>{
    let status = true;
    if(!this.state.review){
      status =  !(this.props.outreach.fileuploaded && this.state.disclaimer);
    }else{
      status =  !this.props.outreach.fileuploaded;
    }
    if(this.state.justpreview){
      status = false;
    }
    return status;
  }
  handleDisclaimer =(event)=>{
    this.setState({
      disclaimer:!this.state.disclaimer
    })
  }

  closeModal() {
    this.props.fileUploadModalclose();
  }

  addCampaign = () =>{
    
  }
  handleDrop = (files, event) => {
    this.filereader = new FileReader();
    this.filereader.onloadend = (e)=>{
      this.setState({
        csvfile: this.filereader.result,
        filename:files[0].name
      },this.importCSV(this.filereader.result,files[0].name));
    }
    this.filereader.readAsText(files[0]);
  }
  importCSV = (result,filename) => {
    let csvjsondata = CSV.parse(result)
    const  csvarray = this.customParser(csvjsondata);
    console.log("csvarray",csvarray);
    this.setState({
      csvdata:csvarray,
      fileloaded:true
    })
    this.props.addContacts(csvarray,filename);
  };
  
  customParser = (data) => {
    const alternateName = ["firstname", "fullname", "names", "firstnamelastname","lastnamefirstname","namelastfirst","namefirstlast","fullnames","lastfirst","namefirstmiddlelast","customers","clients","namefirstlasttitle","namelastfirsttitle","nametitle","titlelastname","contactperson","customername","clientname","primarycontact","name"];
    const alternatePhone = ["phonenumber","telephone","contactnumber","mobile","cellphone","mobilenumber","contactphone","phonecontact","telephonenumber","cellnumber","contacttelephone","primaryphone","secondaryphone","homephone","workphone","officephone","personalphone","businessphone","phone","number"];
    let nameIndex = null;
    let phoneIndex = null;
    for(let i=0;i<data[0].length;i++){
      const column = data[0][i].toLowerCase().replace(/[^a-zA-Z]/g, '');
      if(alternateName.includes(column) && nameIndex === null){
        nameIndex = i;
      }
      if(alternatePhone.includes(column) && phoneIndex === null){
        phoneIndex = i;
      }
    }
    let parserdCSVData = [];
    for(let i=1;i<data.length;i++){
      parserdCSVData.push({ 'name':data[i][nameIndex] ,'phone':data[i][phoneIndex]})
    }
    return parserdCSVData;
  }
  parseCsvFile =(data, fileInfo)=>{
      const parserdCSVData = this.customParser(data);
      this.props.addContacts(parserdCSVData,fileInfo.name);
      this.setState({csvdata:parserdCSVData,fileloaded:true,filename:fileInfo.name})
  }

  sendData=()=>{
    console.log(this.state);
    if(this.state.justpreview){
      this.setState({
        review:false,
        justpreview:false
      });
    }
    if(this.state.review){
    // this.props.closeFileModal(this.state.csvdata);
    // this.resetFile();
    this.closeModal();
    }else{
      this.setState({review:true});
    }
    
  }

  resetFile = ()=>{
    this.setState({
      csvfile:undefined,
      csvdata:[],
      fileloaded:false,
      filename:undefined,
      review:false
    })
    console.log(this.props.outreach.campaign.id)
    this.props.removeContacts(this.props.outreach.campaign.id,true);
  }

  goBack=()=>{
    if(this.state.justpreview){
      this.closeModal();
    }
    if(this.state.review){
        this.setState({
          review:false
        })
    }else{
      // this.resetFile();
      this.closeModal();
    }
    
  }

   formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '' : '';
      return [intlCode, '(', match[2], ') ', match[3], ' ', match[4]].join('');
    } else {
      return phoneNumberString;
    }
  };

  render() {
    const {openFileModal,outreach} = this.props;
    const {campaign,outreaches} = outreach;
    console.log(this.state);
    const {filename,fileloaded,disclaimer,review,csvdata}=this.state;
    return (
      <div>
        <Modal
          isOpen={openFileModal}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="file-modal"
          overlayClassName="file-overlay"
          contentLabel="Example Modal"
        >
          <div className="file">
            <div className="modal-header">
              <div className="title">Import Contacts</div>
              <div className="modal-closing" onClick={this.closeModal}>X</div>
            </div>
            <div className="modal-body">
              {!review?(<>
                <div className="title">Upload your file</div>
                <div className="description">Before you upload your file make sure it is formated properly and ready to be imported. 
                <span className="read-more"><a href={window.Config.OUTREACH_CONFIG.CSV_FAQ} target='_blank'>Read more about csv here</a></span>
                  <span className="download"><CSVLink filename={'sample.csv'} data={this.state.sampledata}>Download a sample CSV here.</CSVLink></span>
                  </div>
                    <div className={classnames('file-drop-container',{'full-border':outreach.fileuploaded})}>
                    <FileDrop onDrop={this.handleDrop}>
                      <div className="icon">
                          {!outreach.fileuploaded?
                          (<i className="material-icons">cloud_upload</i>):(<i className="material-icons green">check_circle</i>)
                          }
                      </div>
                      <div className="drag-text">
                      {!outreach.fileuploaded?
                          'Drag & Drop a CSV file here to upload or':outreach.filename
                      } 
                      </div>
                      <div className="select-text">
                      {!outreach.fileuploaded?
                      <CSVReader
                          cssClass="csv-import"
                          label="Select a file"
                          // onFileLoaded={this.handleForce}
                          onFileLoaded={(data, fileInfo) => this.parseCsvFile(data,fileInfo)}
                          onError={this.handleDarkSideForce}
                          parserOptions={papaparseOptions}
                          inputId="ObiWan"
                        /> :
                        <span onClick={this.resetFile}>Remove</span>
                      }
                      </div>
                    </FileDrop>
                 </div>
                 {outreach.contactfailed && <div className="errormessage">{outreach.errormessage}</div> }
                 <div className="disclaimer">
                   <div className="tick"><input value={disclaimer} type="checkbox"  onChange={this.handleDisclaimer} checked={disclaimer}/></div>
                   <div className="text">I agree that all contacts in this import are expecting to hear from my business. 
                     I have a prior relationship with these contacts and they have 
                     opted in to receiving communication via SMS. I understand that {(this.props.business)?this.props.business.info.BUSINESS_NAME:'we'} bears full responsibility for complying with Telephone Consumer Protection Act (TCPA) and any other rules and regulations in the local jurisdiction related to SMS-based promotional and transactional messaging.
                     </div>
                 </div>
                </>):
                (<>
                  <div className="title">Review your list  <span>({campaign.contacts.length} rows uploaded, {campaign.contacts_count} unique numbers found)</span></div>
                  <div className="contact">
                      <div className="header">
                        <div>NAME</div>
                        <div>PHONE NUMBER</div>
                      </div>
                      <div className="body">
                      {campaign.contacts.map(contact=>{
                        return <div className="list">
                        <div>{contact.name}</div>
                        <div>{this.formatPhoneNumber(contact.phone)}</div>
                      </div>
                      })}
                      </div>
                  </div>
                  </>
                )
                }
            </div>
            <div className="modal-footer">
              <div className="back" onClick={this.goBack}>
                <span className="icon"><i className="material-icons">arrow_back</i></span>Back
              </div>
              <button className="btn btn--primary btn--lg csv-import" onClick={this.sendData} disabled={this.disableButton()}>
                  {review?'FINISH':'NEXT'}
              </button>
            </div>
          </div>

          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default Layover;

